// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DokaOverlay {
    position: relative;
    overflow: hidden;
}

.DokaOverlay > img {
    display: block;
    width: 100%;
    height: auto;
}

.DokaOverlay > .DokaContainer {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
}`, "",{"version":3,"sources":["webpack://./_devapp/react-doka/index.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;AAChB","sourcesContent":[".DokaOverlay {\n    position: relative;\n    overflow: hidden;\n}\n\n.DokaOverlay > img {\n    display: block;\n    width: 100%;\n    height: auto;\n}\n\n.DokaOverlay > .DokaContainer {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
